<script lang="ts">
    
    import { room } from "../../Services";
    import Picture from "../Shared/Picture.svelte";

</script>

{#if $room}
<div class="room-bar">
    <div class="room" class:limit-width={$$slots.default}>
        <div class="picture">
            <Picture id={$room.pictureId} />
        </div>
        {$room.name.value}
    </div>
    {#if $$slots.default}
        <div class="sloted">
            <slot />
        </div>
    {/if}
</div>
{/if}

<style lang="scss">

    $picture-size: 4.5rem;

    .room-bar {
        font-family: Title;
        width: 100%;
        box-sizing: border-box;
        display: flex;
        gap: 1rem;
        padding: 1rem;
        background-color: #fff;
        color: #000;
    }

    .room {
        flex: 1 1 0;
        display: flex;
        align-items: center;
        gap: 0.5rem;

        &.limit-width {
            max-width: 50%;
        }
    }

    .sloted {
        flex: 1 1 0;
        display: flex;
        justify-content: flex-end;
    }

    .picture {
        width: $picture-size;
        height: $picture-size;
    }

</style>

